export default "__VITE_ASSET__Dain$bKD__"